export const BRAND = {
  name: "Kumarasiri Foods",
  phone: "0710880290",
  addressLines: ["No 188", "Iddamaldeniya, Dompe"],
  storageKey: "FOODS",
  invoicePrefix: "KF",
  colors: {
    primary: "#9E1713",
    primaryDark: "#7A120F",
    white: "#FFFFFF",
    chart: ["#9E1713", "#D96560", "#68100D", "#EBA6A3", "#B43B36", "#8A6563", "#4D0B09"],
  },
};
